import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  // Hacemos público el BehaviorSubject para que el interceptor pueda actualizarlo
  isOnline = new BehaviorSubject<boolean>(true);
  private readonly isBrowser: boolean;

  constructor() {
    this.isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    if (this.isBrowser) {
      // Inicializar con el estado actual del navegador
      this.isOnline.next(navigator.onLine);

      // Configurar los event listeners para detectar cambios en la conexión
      fromEvent(window, 'online').subscribe(() => this.isOnline.next(true));
      fromEvent(window, 'offline').subscribe(() => this.isOnline.next(false));
    }
    // En el servidor, asumimos que siempre hay conexión
  }

  /**
   * Obtiene un Observable que emite el estado actual de la conexión
   * y notifica cuando cambia
   */
  getNetworkStatus(): Observable<boolean> {
    return this.isOnline.asObservable();
  }

  /**
   * Retorna el estado actual de la conexión
   */
  getCurrentStatus(): boolean {
    return this.isOnline.getValue();
  }
}
